var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#178FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5711_7463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0104 15.0373C17.0104 14.9627 16.9296 14.9627 16.9296 14.9627C15.234 14.8137 13.6191 14.6646 11.9234 14.5901C11.5197 14.5901 11.116 14.5155 10.7122 14.5155C10.6315 14.5155 10.6315 14.5155 10.6315 14.441C10.3085 13.0248 9.90477 11.6087 9.50105 10.2671C9.4203 9.89441 9.58179 9.52174 9.90477 9.29814C10.3085 9 10.7122 8.92547 11.116 9.07453C11.6812 9.29814 12.2464 9.59627 12.8116 9.81988C15.7992 11.236 18.7868 12.6522 21.7743 14.0683C22.2588 14.2919 22.501 14.5901 22.501 15.0373C22.501 15.4845 22.2588 15.7826 21.8551 15.9317C20.4824 16.5279 19.1905 17.1988 17.8178 17.795C15.6377 18.8385 13.3768 19.8075 11.1967 20.8509C10.47 21.1491 9.74328 20.8509 9.58179 20.1801C9.50105 20.0311 9.58179 19.8075 9.58179 19.6584C9.90477 18.3168 10.3085 17.0497 10.6315 15.7081C10.6315 15.6335 10.7122 15.559 10.793 15.559C11.8427 15.4845 12.9731 15.4099 14.0228 15.2609C14.911 15.1863 15.7992 15.1118 16.6066 15.0373C16.7681 15.0373 16.8489 15.0373 17.0104 15.0373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5711_7463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white",
    transform: "translate(9.5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chatSendIcon.fcaa47a72f37f68df91908d1dbadc934.svg";
export { ForwardRef as ReactComponent };